module.exports = __webpack_public_path__ + "img/loginlogo.3e54718e.svg";